import {stylesheet} from "typestyle";

export const commonStyles = stylesheet({
    viewHeader: {
        boxShadow: '0 0.1em 0.3em -0.1em rgba(0, 0, 0, 0.5)',
        zIndex: 1,
    },
    selectionViewContent: {
        background: '#f6f6f6',
    }
});

